import { render, staticRenderFns } from "./LackRecords.vue?vue&type=template&id=2b756543&scoped=true&"
import script from "./LackRecords.vue?vue&type=script&lang=js&"
export * from "./LackRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b756543",
  null
  
)

export default component.exports